import { render, staticRenderFns } from "./CoursewareBiographyPersonalInformationBlock.vue?vue&type=template&id=571e506e&scoped=true&"
import script from "./CoursewareBiographyPersonalInformationBlock.vue?vue&type=script&lang=js&"
export * from "./CoursewareBiographyPersonalInformationBlock.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareBiographyPersonalInformationBlock.vue?vue&type=style&index=0&id=571e506e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571e506e",
  null
  
)

export default component.exports